// extracted by mini-css-extract-plugin
export default {"card":"VipCard_card__wwad9","imageContainer":"VipCard_imageContainer__7xOdn","caption":"VipCard_caption__3Wygg"};